'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var path = require('path');

var EventEmitter = require('events').EventEmitter;

var mapSeries = require('p-each-series');

var _require = require('p-queue'),
    PQueue = _require.default;

var Log = require('ipfs-log');

var Entry = Log.Entry;

var Index = require('./Index');

var Replicator = require('./Replicator');

var ReplicationInfo = require('./replication-info');

var Logger = require('logplease');

var logger = Logger.create('orbit-db.store', {
  color: Logger.Colors.Blue
});
Logger.setLogLevel('ERROR');

var io = require('orbit-db-io');

var DefaultOptions = {
  Index: Index,
  maxHistory: -1,
  fetchEntryTimeout: null,
  referenceCount: 32,
  replicationConcurrency: 128,
  syncLocal: false,
  sortFn: undefined
};

var Store = /*#__PURE__*/function () {
  function Store(ipfs, identity, address, options) {
    var _this = this;

    _classCallCheck(this, Store);

    if (!identity) {
      throw new Error('Identity required');
    } // Set the options


    var opts = Object.assign({}, DefaultOptions);
    Object.assign(opts, options);
    this.options = opts; // Default type

    this._type = 'store'; // Create IDs, names and paths

    this.id = address.toString();
    this.identity = identity;
    this.address = address;
    this.dbname = address.path || '';
    this.events = new EventEmitter();
    this.remoteHeadsPath = path.join(this.id, '_remoteHeads');
    this.localHeadsPath = path.join(this.id, '_localHeads');
    this.snapshotPath = path.join(this.id, 'snapshot');
    this.queuePath = path.join(this.id, 'queue');
    this.manifestPath = path.join(this.id, '_manifest'); // External dependencies

    this._ipfs = ipfs;
    this._cache = options.cache; // Access mapping

    var defaultAccess = {
      canAppend: function canAppend(entry) {
        return entry.identity.publicKey === identity.publicKey;
      }
    };
    this.access = options.accessController || defaultAccess; // Create the operations log

    this._oplog = new Log(this._ipfs, this.identity, {
      logId: this.id,
      access: this.access,
      sortFn: this.options.sortFn
    }); // _addOperation queue

    this._opqueue = new PQueue({
      concurrency: 1
    }); // Create the index

    this._index = new this.options.Index(this.address.root); // Replication progress info

    this._replicationStatus = new ReplicationInfo(); // Statistics

    this._stats = {
      snapshot: {
        bytesLoaded: -1
      },
      syncRequestsReceieved: 0
    };

    try {
      this._replicator = new Replicator(this, this.options.replicationConcurrency); // For internal backwards compatibility,
      // to be removed in future releases

      this._loader = this._replicator;

      this._replicator.on('load.added', function (entry) {
        // Update the latest entry state (latest is the entry with largest clock time)
        _this._replicationStatus.queued++;

        _this._recalculateReplicationMax(entry.clock ? entry.clock.time : 0); // logger.debug(`<replicate>`)


        _this.events.emit('replicate', _this.address.toString(), entry);
      });

      this._replicator.on('load.progress', function (id, hash, entry, have, bufferedLength) {
        if (_this._replicationStatus.buffered > bufferedLength) {
          _this._recalculateReplicationProgress(_this.replicationStatus.progress + bufferedLength);
        } else {
          _this._recalculateReplicationProgress(_this._oplog.length + bufferedLength);
        }

        _this._replicationStatus.buffered = bufferedLength;

        _this._recalculateReplicationMax(_this.replicationStatus.progress); // logger.debug(`<replicate.progress>`)


        _this.events.emit('replicate.progress', _this.address.toString(), hash, entry, _this.replicationStatus.progress, _this.replicationStatus.max);
      });

      var onLoadCompleted = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(logs, have) {
          var _iterator2, _step2, log, heads;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _iterator2 = _createForOfIteratorHelper(logs);
                  _context.prev = 2;

                  _iterator2.s();

                case 4:
                  if ((_step2 = _iterator2.n()).done) {
                    _context.next = 10;
                    break;
                  }

                  log = _step2.value;
                  _context.next = 8;
                  return _this._oplog.join(log);

                case 8:
                  _context.next = 4;
                  break;

                case 10:
                  _context.next = 15;
                  break;

                case 12:
                  _context.prev = 12;
                  _context.t0 = _context["catch"](2);

                  _iterator2.e(_context.t0);

                case 15:
                  _context.prev = 15;

                  _iterator2.f();

                  return _context.finish(15);

                case 18:
                  _this._replicationStatus.queued -= logs.length;
                  _this._replicationStatus.buffered = _this._replicator._buffer.length;
                  _context.next = 22;
                  return _this._updateIndex();

                case 22:
                  // only store heads that has been verified and merges
                  heads = _this._oplog.heads;
                  _context.next = 25;
                  return _this._cache.set(_this.remoteHeadsPath, heads);

                case 25:
                  logger.debug("Saved heads ".concat(heads.length, " [").concat(heads.map(function (e) {
                    return e.hash;
                  }).join(', '), "]")); // logger.debug(`<replicated>`)

                  _this.events.emit('replicated', _this.address.toString(), logs.length);

                  _context.next = 32;
                  break;

                case 29:
                  _context.prev = 29;
                  _context.t1 = _context["catch"](0);
                  console.error(_context.t1);

                case 32:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 29], [2, 12, 15, 18]]);
        }));

        return function onLoadCompleted(_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }();

      this._replicator.on('load.end', onLoadCompleted);
    } catch (e) {
      console.error('Store Error:', e);
    }

    this.events.on('replicated.progress', function (address, hash, entry, progress, have) {
      _this._procEntry(entry);
    });
    this.events.on('write', function (address, entry, heads) {
      _this._procEntry(entry);
    });
  }

  _createClass(Store, [{
    key: "all",
    get: function get() {
      var _this2 = this;

      return Array.isArray(this._index._index) ? this._index._index : Object.keys(this._index._index).map(function (e) {
        return _this2._index._index[e];
      });
    }
  }, {
    key: "index",
    get: function get() {
      return this._index._index;
    }
  }, {
    key: "type",
    get: function get() {
      return this._type;
    }
  }, {
    key: "key",
    get: function get() {
      return this._key;
    }
    /**
     * Returns the database's current replication status information
     * @return {[Object]} [description]
     */

  }, {
    key: "replicationStatus",
    get: function get() {
      return this._replicationStatus;
    }
  }, {
    key: "setIdentity",
    value: function setIdentity(identity) {
      this.identity = identity;

      this._oplog.setIdentity(identity);
    }
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var event;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.options.onClose) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return this.options.onClose(this);

              case 3:
                _context2.next = 5;
                return this._opqueue.onIdle();

              case 5:
                // Replicator teardown logic
                this._replicator.stop(); // Reset replication statistics


                this._replicationStatus.reset(); // Reset database statistics


                this._stats = {
                  snapshot: {
                    bytesLoaded: -1
                  },
                  syncRequestsReceieved: 0
                }; // Remove all event listeners

                for (event in this.events._events) {
                  this.events.removeAllListeners(event);
                } // Database is now closed
                // TODO: afaik we don't use 'closed' event anymore,
                // to be removed in future releases


                this.events.emit('closed', this.address.toString());
                return _context2.abrupt("return", Promise.resolve());

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
    /**
     * Drops a database and removes local data
     * @return {[None]}
     */

  }, {
    key: "drop",
    value: function () {
      var _drop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.options.onDrop) {
                  _context3.next = 3;
                  break;
                }

                _context3.next = 3;
                return this.options.onDrop(this);

              case 3:
                _context3.next = 5;
                return this._cache.del(this.localHeadsPath);

              case 5:
                _context3.next = 7;
                return this._cache.del(this.remoteHeadsPath);

              case 7:
                _context3.next = 9;
                return this._cache.del(this.snapshotPath);

              case 9:
                _context3.next = 11;
                return this._cache.del(this.queuePath);

              case 11:
                _context3.next = 13;
                return this._cache.del(this.manifestPath);

              case 13:
                _context3.next = 15;
                return this.close();

              case 15:
                // Reset
                this._index = new this.options.Index(this.address.root);
                this._oplog = new Log(this._ipfs, this.identity, {
                  logId: this.id,
                  access: this.access,
                  sortFn: this.options.sortFn
                });
                this._cache = this.options.cache;

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function drop() {
        return _drop.apply(this, arguments);
      }

      return drop;
    }()
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(amount) {
        var _this3 = this;

        var opts,
            fetchEntryTimeout,
            localHeads,
            remoteHeads,
            heads,
            log,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                opts = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};

                if (typeof amount === 'object') {
                  opts = amount;
                  amount = undefined;
                }

                amount = amount || this.options.maxHistory;
                fetchEntryTimeout = opts.fetchEntryTimeout || this.options.fetchEntryTimeout;

                if (!this.options.onLoad) {
                  _context4.next = 7;
                  break;
                }

                _context4.next = 7;
                return this.options.onLoad(this);

              case 7:
                _context4.next = 9;
                return this._cache.get(this.localHeadsPath);

              case 9:
                _context4.t0 = _context4.sent;

                if (_context4.t0) {
                  _context4.next = 12;
                  break;
                }

                _context4.t0 = [];

              case 12:
                localHeads = _context4.t0;
                _context4.next = 15;
                return this._cache.get(this.remoteHeadsPath);

              case 15:
                _context4.t1 = _context4.sent;

                if (_context4.t1) {
                  _context4.next = 18;
                  break;
                }

                _context4.t1 = [];

              case 18:
                remoteHeads = _context4.t1;
                heads = localHeads.concat(remoteHeads);

                if (heads.length > 0) {
                  this.events.emit('load', this.address.toString(), heads);
                } // Update the replication status from the heads


                heads.forEach(function (h) {
                  return _this3._recalculateReplicationMax(h.clock.time);
                }); // Load the log

                _context4.next = 24;
                return Log.fromEntryHash(this._ipfs, this.identity, heads.map(function (e) {
                  return e.hash;
                }), {
                  logId: this._oplog.id,
                  access: this.access,
                  sortFn: this.options.sortFn,
                  length: amount,
                  exclude: this._oplog.values,
                  onProgressCallback: this._onLoadProgress.bind(this),
                  timeout: fetchEntryTimeout
                });

              case 24:
                log = _context4.sent;
                _context4.next = 27;
                return this._oplog.join(log, amount);

              case 27:
                if (!(heads.length > 0)) {
                  _context4.next = 30;
                  break;
                }

                _context4.next = 30;
                return this._updateIndex();

              case 30:
                this.events.emit('ready', this.address.toString(), this._oplog.heads);

              case 31:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function load(_x3) {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "sync",
    value: function () {
      var _sync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(heads) {
        var _this4 = this;

        var saveToIpfs, saved;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this._stats.syncRequestsReceieved += 1;
                logger.debug("Sync request #".concat(this._stats.syncRequestsReceieved, " ").concat(heads.length));

                if (!(heads.length === 0)) {
                  _context6.next = 4;
                  break;
                }

                return _context6.abrupt("return");

              case 4:
                // To simulate network latency, uncomment this line
                // and comment out the rest of the function
                // That way the object (received as head message from pubsub)
                // doesn't get written to IPFS and so when the Replicator is fetching
                // the log, it'll fetch it from the network instead from the disk.
                // return this._replicator.load(heads)
                saveToIpfs = /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(head) {
                    var identityProvider, canAppend, logEntry, hash;
                    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            if (head) {
                              _context5.next = 3;
                              break;
                            }

                            console.warn("Warning: Given input entry was 'null'.");
                            return _context5.abrupt("return", Promise.resolve(null));

                          case 3:
                            identityProvider = _this4.identity.provider;

                            if (identityProvider) {
                              _context5.next = 6;
                              break;
                            }

                            throw new Error('Identity-provider is required, cannot verify entry');

                          case 6:
                            _context5.next = 8;
                            return _this4.access.canAppend(head, identityProvider);

                          case 8:
                            canAppend = _context5.sent;

                            if (canAppend) {
                              _context5.next = 12;
                              break;
                            }

                            console.warn('Warning: Given input entry is not allowed in this log and was discarded (no write access).');
                            return _context5.abrupt("return", Promise.resolve(null));

                          case 12:
                            logEntry = Entry.toEntry(head);
                            _context5.next = 15;
                            return io.write(_this4._ipfs, Entry.getWriteFormat(logEntry), logEntry, {
                              links: Entry.IPLD_LINKS,
                              onlyHash: true
                            });

                          case 15:
                            hash = _context5.sent;

                            if (hash !== head.hash) {
                              console.warn('"WARNING! Head hash didn\'t match the contents');
                            }

                            return _context5.abrupt("return", head);

                          case 18:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  }));

                  return function saveToIpfs(_x5) {
                    return _ref2.apply(this, arguments);
                  };
                }();

                _context6.next = 7;
                return mapSeries(heads, saveToIpfs);

              case 7:
                saved = _context6.sent;
                _context6.next = 10;
                return this._replicator.load(saved.filter(function (e) {
                  return e !== null;
                }));

              case 10:
                if (!(this._replicator._buffer.length || Object.values(this._replicator._queue).length)) {
                  _context6.next = 12;
                  break;
                }

                return _context6.abrupt("return", new Promise(function (resolve) {
                  var progressHandler = function progressHandler(address, hash, entry, progress, have) {
                    if (progress === have) {
                      _this4.events.off('replicate.progress', progressHandler);

                      _this4.events.once('replicated', resolve);
                    }
                  };

                  _this4.events.on('replicate.progress', progressHandler);
                }));

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function sync(_x4) {
        return _sync.apply(this, arguments);
      }

      return sync;
    }()
  }, {
    key: "loadMoreFrom",
    value: function loadMoreFrom(amount, entries) {
      this._replicator.load(entries);
    }
  }, {
    key: "saveSnapshot",
    value: function () {
      var _saveSnapshot = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var unfinished, snapshotData, buf, snapshot;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                unfinished = this._replicator.getQueue();
                snapshotData = this._oplog.toSnapshot();
                buf = Buffer.from(JSON.stringify({
                  id: snapshotData.id,
                  heads: snapshotData.heads,
                  size: snapshotData.values.length,
                  values: snapshotData.values,
                  type: this.type
                }));
                _context7.next = 5;
                return this._ipfs.add(buf);

              case 5:
                snapshot = _context7.sent;
                snapshot.hash = snapshot.cid.toString(); // js-ipfs >= 0.41, ipfs.add results contain a cid property (a CID instance) instead of a string hash property

                _context7.next = 9;
                return this._cache.set(this.snapshotPath, snapshot);

              case 9:
                _context7.next = 11;
                return this._cache.set(this.queuePath, unfinished);

              case 11:
                logger.debug("Saved snapshot: ".concat(snapshot.hash, ", queue length: ").concat(unfinished.length));
                return _context7.abrupt("return", [snapshot]);

              case 13:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function saveSnapshot() {
        return _saveSnapshot.apply(this, arguments);
      }

      return saveSnapshot;
    }()
  }, {
    key: "loadFromSnapshot",
    value: function () {
      var _loadFromSnapshot = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(onProgressCallback) {
        var _this5 = this;

        var maxClock, queue, snapshot, chunks, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, buffer, snapshotData, onProgress, log;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!this.options.onLoad) {
                  _context8.next = 3;
                  break;
                }

                _context8.next = 3;
                return this.options.onLoad(this);

              case 3:
                this.events.emit('load', this.address.toString()); // TODO emits inconsistent params, missing heads param

                maxClock = function maxClock(res, val) {
                  return Math.max(res, val.clock.time);
                };

                _context8.next = 7;
                return this._cache.get(this.queuePath);

              case 7:
                queue = _context8.sent;
                this.sync(queue || []);
                _context8.next = 11;
                return this._cache.get(this.snapshotPath);

              case 11:
                snapshot = _context8.sent;

                if (!snapshot) {
                  _context8.next = 63;
                  break;
                }

                chunks = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context8.prev = 16;
                _iterator = _asyncIterator(this._ipfs.cat(snapshot.hash));

              case 18:
                _context8.next = 20;
                return _iterator.next();

              case 20:
                _step = _context8.sent;
                _iteratorNormalCompletion = _step.done;
                _context8.next = 24;
                return _step.value;

              case 24:
                _value = _context8.sent;

                if (_iteratorNormalCompletion) {
                  _context8.next = 31;
                  break;
                }

                chunk = _value;
                chunks.push(chunk);

              case 28:
                _iteratorNormalCompletion = true;
                _context8.next = 18;
                break;

              case 31:
                _context8.next = 37;
                break;

              case 33:
                _context8.prev = 33;
                _context8.t0 = _context8["catch"](16);
                _didIteratorError = true;
                _iteratorError = _context8.t0;

              case 37:
                _context8.prev = 37;
                _context8.prev = 38;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context8.next = 42;
                  break;
                }

                _context8.next = 42;
                return _iterator.return();

              case 42:
                _context8.prev = 42;

                if (!_didIteratorError) {
                  _context8.next = 45;
                  break;
                }

                throw _iteratorError;

              case 45:
                return _context8.finish(42);

              case 46:
                return _context8.finish(37);

              case 47:
                buffer = Buffer.concat(chunks);
                snapshotData = JSON.parse(buffer.toString());

                onProgress = function onProgress(hash, entry, count, total) {
                  _this5._recalculateReplicationStatus(count, entry.clock.time);

                  _this5._onLoadProgress(hash, entry);
                }; // Fetch the entries
                // Timeout 1 sec to only load entries that are already fetched (in order to not get stuck at loading)


                this._recalculateReplicationMax(snapshotData.values.reduce(maxClock, 0));

                if (!snapshotData) {
                  _context8.next = 60;
                  break;
                }

                _context8.next = 54;
                return Log.fromJSON(this._ipfs, this.identity, snapshotData, {
                  access: this.access,
                  sortFn: this.options.sortFn,
                  length: -1,
                  timeout: 1000,
                  onProgressCallback: onProgress
                });

              case 54:
                log = _context8.sent;
                _context8.next = 57;
                return this._oplog.join(log);

              case 57:
                _context8.next = 59;
                return this._updateIndex();

              case 59:
                this.events.emit('replicated', this.address.toString()); // TODO: inconsistent params, count param not emited

              case 60:
                this.events.emit('ready', this.address.toString(), this._oplog.heads);
                _context8.next = 64;
                break;

              case 63:
                throw new Error("Snapshot for ".concat(this.address, " not found!"));

              case 64:
                return _context8.abrupt("return", this);

              case 65:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[16, 33, 37, 47], [38,, 42, 46]]);
      }));

      function loadFromSnapshot(_x6) {
        return _loadFromSnapshot.apply(this, arguments);
      }

      return loadFromSnapshot;
    }()
  }, {
    key: "_updateIndex",
    value: function () {
      var _updateIndex2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this._recalculateReplicationMax();

                _context9.next = 3;
                return this._index.updateIndex(this._oplog);

              case 3:
                this._recalculateReplicationProgress();

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function _updateIndex() {
        return _updateIndex2.apply(this, arguments);
      }

      return _updateIndex;
    }()
  }, {
    key: "syncLocal",
    value: function () {
      var _syncLocal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var localHeads, remoteHeads, heads, i, head;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this._cache.get(this.localHeadsPath);

              case 2:
                _context10.t0 = _context10.sent;

                if (_context10.t0) {
                  _context10.next = 5;
                  break;
                }

                _context10.t0 = [];

              case 5:
                localHeads = _context10.t0;
                _context10.next = 8;
                return this._cache.get(this.remoteHeadsPath);

              case 8:
                _context10.t1 = _context10.sent;

                if (_context10.t1) {
                  _context10.next = 11;
                  break;
                }

                _context10.t1 = [];

              case 11:
                remoteHeads = _context10.t1;
                heads = localHeads.concat(remoteHeads);
                i = 0;

              case 14:
                if (!(i < heads.length)) {
                  _context10.next = 23;
                  break;
                }

                head = heads[i];

                if (this._oplog.heads.includes(head)) {
                  _context10.next = 20;
                  break;
                }

                _context10.next = 19;
                return this.load();

              case 19:
                return _context10.abrupt("break", 23);

              case 20:
                i++;
                _context10.next = 14;
                break;

              case 23:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function syncLocal() {
        return _syncLocal.apply(this, arguments);
      }

      return syncLocal;
    }()
  }, {
    key: "_addOperation",
    value: function () {
      var _addOperation2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(data) {
        var _ref3,
            onProgressCallback,
            _ref3$pin,
            pin,
            addOperation,
            _addOperation3,
            _args12 = arguments;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _addOperation3 = function _addOperation5() {
                  _addOperation3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
                    var entry;
                    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                      while (1) {
                        switch (_context11.prev = _context11.next) {
                          case 0:
                            if (!this._oplog) {
                              _context11.next = 15;
                              break;
                            }

                            if (!this.options.syncLocal) {
                              _context11.next = 4;
                              break;
                            }

                            _context11.next = 4;
                            return this.syncLocal();

                          case 4:
                            _context11.next = 6;
                            return this._oplog.append(data, this.options.referenceCount, pin);

                          case 6:
                            entry = _context11.sent;

                            this._recalculateReplicationStatus(this.replicationStatus.progress + 1, entry.clock.time);

                            _context11.next = 10;
                            return this._cache.set(this.localHeadsPath, [entry]);

                          case 10:
                            _context11.next = 12;
                            return this._updateIndex();

                          case 12:
                            this.events.emit('write', this.address.toString(), entry, this._oplog.heads);
                            if (onProgressCallback) onProgressCallback(entry);
                            return _context11.abrupt("return", entry.hash);

                          case 15:
                          case "end":
                            return _context11.stop();
                        }
                      }
                    }, _callee11, this);
                  }));
                  return _addOperation3.apply(this, arguments);
                };

                addOperation = function _addOperation4() {
                  return _addOperation3.apply(this, arguments);
                };

                _ref3 = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : {}, onProgressCallback = _ref3.onProgressCallback, _ref3$pin = _ref3.pin, pin = _ref3$pin === void 0 ? false : _ref3$pin;
                return _context12.abrupt("return", this._opqueue.add(addOperation.bind(this)));

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function _addOperation(_x7) {
        return _addOperation2.apply(this, arguments);
      }

      return _addOperation;
    }()
  }, {
    key: "_addOperationBatch",
    value: function _addOperationBatch(data, batchOperation, lastOperation, onProgressCallback) {
      throw new Error('Not implemented!');
    }
  }, {
    key: "_procEntry",
    value: function _procEntry(entry) {
      var payload = entry.payload,
          hash = entry.hash;
      var op = payload.op;

      if (op) {
        this.events.emit("log.op.".concat(op), this.address.toString(), hash, payload);
      } else {
        this.events.emit('log.op.none', this.address.toString(), hash, payload);
      }

      this.events.emit('log.op', op, this.address.toString(), hash, payload);
    }
  }, {
    key: "_onLoadProgress",
    value: function _onLoadProgress(hash, entry, progress, total) {
      this._recalculateReplicationStatus(progress, total);

      this.events.emit('load.progress', this.address.toString(), hash, entry, this.replicationStatus.progress, this.replicationStatus.max);
    }
    /* Replication Status state updates */

  }, {
    key: "_recalculateReplicationProgress",
    value: function _recalculateReplicationProgress(max) {
      this._replicationStatus.progress = Math.max.apply(null, [this._replicationStatus.progress, this._oplog.length, max || 0]);

      this._recalculateReplicationMax(this.replicationStatus.progress);
    }
  }, {
    key: "_recalculateReplicationMax",
    value: function _recalculateReplicationMax(max) {
      this._replicationStatus.max = Math.max.apply(null, [this._replicationStatus.max, this._oplog.length, max || 0]);
    }
  }, {
    key: "_recalculateReplicationStatus",
    value: function _recalculateReplicationStatus(maxProgress, maxTotal) {
      this._recalculateReplicationProgress(maxProgress);

      this._recalculateReplicationMax(maxTotal);
    }
  }]);

  return Store;
}();

module.exports = Store;
module.exports.DefaultOptions = DefaultOptions;